import React from "react";

import * as S from "../styled";
import { ModalContext } from "../SuccessMessageModal";

function CustomContent(props) {
  return (
    <ModalContext.Consumer>
      {context => <S.CustomContent {...props} layout={context.layout} />}
    </ModalContext.Consumer>
  );
}

export default CustomContent;
